import { useMediaQuery } from '@mantine/hooks'

import { theme } from '@/theme'

export const useBreakpoint = (
	breakpoint: keyof typeof theme.screens,
	options: {
		ssrFallback?: boolean
	} = {},
) => {
	const queryResult = useMediaQuery(`(min-width: ${theme.screens[breakpoint]})`)

	if (options.ssrFallback !== undefined && typeof window === 'undefined') {
		return options.ssrFallback
	}

	return queryResult
}
